// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page .title, .page .msg {
  word-break: break-all;
  word-break: break-word;
}

.page {
  padding: 20px 20px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.page .icon {
  align-self: center;
  margin-bottom: 10px;
  font-size: 25px;
  position: absolute;
}
.page .msg {
  margin-bottom: 20px;
  padding: 0 10px;
  color: var(--app-mid);
  font-size: 14px;
  line-height: 1.3;
}
.page .pg-btns {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.page .pg-btns .pg-btn:not(:last-child) {
  margin-right: 10px;
}
.page .pg-btn {
  align-self: flex-end;
  margin: 0;
}
.page .pg-btn.pg-btn-close {
  margin-top: -10px;
  margin-right: -10px;
  --border-radius: 50%;
  --padding-top: 5px;
  --padding-bottom: 5px;
  --padding-start: 5px;
  --padding-end: 5px;
  height: auto;
}
.page .pg-btn.pg-btn-close .btn-icon {
  font-size: 24px;
}
.page .pg-btn.pg-btn-ok {
  height: 32px;
  min-width: 70px;
  font-weight: 600;
}
.page .title {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0 10px;
  color: var(--app-mid);
  font-size: 17px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/small-alert/small-alert.page.scss"],"names":[],"mappings":"AAQA;EACE,qBAAA;EAEA,sBAAA;AARF;;AAWA;EACC,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,sBAAA;AATD;AAaC;EACC,kBAAA;EAGE,mBAAA;EAEF,eAAA;EACE,kBAAA;AAdJ;AAkBC;EACC,mBAAA;EACA,eAAA;EAEA,qBAAA;EACE,eAAA;EACF,gBAAA;AAjBF;AAuBC;EACC,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,yBAAA;AAtBF;AAyBG;EACC,kBAAA;AAvBJ;AA4BC;EACC,oBAAA;EACA,SAAA;AA1BF;AA4BE;EACC,iBAAA;EACA,mBAAA;EAEA,oBAAA;EAGA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;AA9BH;AAgCG;EACC,eAAA;AA9BJ;AAkCE;EAGC,YAAA;EACA,eAAA;EAEA,gBAAA;AAnCH;AAwCC;EACG,gBAAA;EACF,mBAAA;EACA,eAAA;EAEA,qBAAA;EACA,eAAA;EACA,gBAAA;AAvCF","sourcesContent":["\n\n$page_pt: 20px;\n$page_px: 20px;\n$page_pb: 50px;\n$page_p: $page_pt $page_px $page_pb;\n\n\n%longWord {\n  word-break: break-all;\n  // Edge 79, Firefox 67 - also: deprecated?\n  word-break: break-word;\n}\n\n.page {\n\tpadding: $page_pt $page_px;\n\tmin-height: 100%;\n\t\n\tdisplay: flex;\n\tflex-direction: column;\n\t\n\t\n\t\n\t.icon {\n\t\talign-self: center;\n\t\t\n\t\t//margin-top: 5px;\n    margin-bottom: 10px;\n\t\t\n\t\tfont-size: 25px;\n    position: absolute;\n\t}\n\t\n\t\n\t.msg {\n\t\tmargin-bottom: 20px;\n\t\tpadding: 0 10px;\n\t\t\n\t\tcolor: var(--app-mid);\n    font-size: 14px;\n\t\tline-height: 1.3;\n\t\t\n\t\t@extend %longWord;\n\t}\n\t\n\t\n\t.pg-btns {\n\t\tmargin-top: auto;\n\t\t\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t\t\n\t\t.pg-btn {\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t}\n\t}\n\t\n\t.pg-btn {\n\t\talign-self: flex-end;\n\t\tmargin: 0;\n\t\t\n\t\t&.pg-btn-close {\n\t\t\tmargin-top: -10px;\n\t\t\tmargin-right: -10px;\n\t\t\t\n\t\t\t--border-radius: 50%;\n\t\t\t\n\t\t\t$p: 5px;\n\t\t\t--padding-top: #{$p};\n\t\t\t--padding-bottom: #{$p};\n\t\t\t--padding-start: #{$p};\n\t\t\t--padding-end: #{$p};\n\t\t\t\n\t\t\theight: auto;\n\t\t\t\n\t\t\t.btn-icon {\n\t\t\t\tfont-size: 24px;\n\t\t\t}\n\t\t}\n\t\t\n\t\t&.pg-btn-ok {\n\t\t\t// margin-top: auto;\n\t\t\t\n\t\t\theight: 32px;\n\t\t\tmin-width: 70px;\n\t\t\t\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\t\n\t\n\t.title {\n    margin-top: 10px;\n\t\tmargin-bottom: 10px;\n\t\tpadding: 0 10px;\n\t\t\n\t\tcolor: var(--app-mid);\n\t\tfont-size: 17px;\n\t\tfont-weight: 500;\n\t\t\n\t\t@extend %longWord;\n\t}\n\t\n\t\n}\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
